import { Pipe, PipeTransform } from '@angular/core';
import { ProductSpecification } from '@approot/models/product-info.type';
import { ProductsConfigService } from '@approot/services/products-config/products-config.service';
@Pipe({
  name: 'legMenuProducts'
})
export class LegMenuProductsPipe implements PipeTransform {
  constructor(private productsConfigService: ProductsConfigService) {}
  // gets a product info from its short name
  transform(productShortName: string): ProductSpecification {
    return this.productsConfigService.productInfo.productSpecifications.filter(
      product => product.identifier === productShortName
    )[0];
  }
}
